import { Link } from "@/components";
import { ROUTES } from "@/config";
import { useEffect, useState } from "react";
import { INFINIFI_TWITTER_X } from "@/config/urls.config";

export const Footer = () => {
    const currentYear = new Date().getFullYear();
    const [isVisible, setIsVisible] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 950);
        };

        checkMobile();
        window.addEventListener("resize", checkMobile);

        if (isMobile) {
            const handleScroll = () => {
                const bottom = Math.ceil(window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight;
                setIsVisible(bottom);
            };

            window.addEventListener("scroll", handleScroll);
            return () => {
                window.removeEventListener("scroll", handleScroll);
                window.removeEventListener("resize", checkMobile);
            };
        }
        return () => window.removeEventListener("resize", checkMobile);
    }, [isMobile]);

    return (
        <footer
            className={`w-full py-3 px-8 transition-opacity duration-500 ${
                isMobile ? (isVisible ? "opacity-100" : "opacity-0") : "opacity-70 hover:opacity-100"
            } mt-auto`}
        >
            <div className="container mx-auto">
                <div className="flex flex-col md950:flex-row justify-between items-center space-y-2 md950:space-y-0">
                    <Link
                        href="https://infinifi.xyz"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-dark hover:text-primary transition-colors "
                    >
                        © {currentYear} infiniFi
                    </Link>
                    <div className="flex space-x-6">
                        <Link href={ROUTES.TERMS} className="text-dark hover:text-primary transition-colors ">
                            Terms
                        </Link>
                        <Link
                            href="https://docs.infinifi.xyz"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-dark hover:text-primary  transition-colors "
                        >
                            Docs
                        </Link>
                        <Link
                            href="https://stats.infinifi.xyz/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-dark hover:text-primary  transition-colors "
                        >
                            Stats
                        </Link>
                        <Link
                            href={INFINIFI_TWITTER_X}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-dark hover:text-primary  transition-colors "
                        >
                            Twitter
                        </Link>
                        <Link
                            href="https://discord.gg/infinifi"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-dark hover:text-primary  transition-colors "
                        >
                            Discord
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};
